import { FolderOpenIcon } from "lucide-react";
import { useCallback, useState } from "react";

import { m } from "@/paraglide/messages";

import {
	PromptInputActionAddAttachments,
	PromptInputActionMenu,
	PromptInputActionMenuContent,
	PromptInputActionMenuItem,
	PromptInputActionMenuTrigger,
	usePromptInputAttachments,
} from "../ai-elements/prompt-input";
import { ResourcePickerDialog } from "./resource-picker-dialog";

/**
 * Dropdown menu (with "Add photos or files" + "Resources" items) + resource picker dialog.
 * Renders the dialog as a sibling of DropdownMenu so it survives dropdown unmount.
 * Must be rendered inside <PromptInput> to access attachments context.
 */
export function ResourcePickerAction() {
	const [dialogOpen, setDialogOpen] = useState(false);
	const attachments = usePromptInputAttachments();

	const handleConfirm = useCallback(
		(files: { id: string; url: string; fileType: string; name: string }[]) => {
			attachments.addFromUrls(
				files.map((f) => ({
					url: f.url,
					mediaType: f.fileType,
					filename: f.name,
				})),
			);
			setDialogOpen(false);
		},
		[attachments],
	);

	return (
		<>
			<PromptInputActionMenu>
				<PromptInputActionMenuTrigger />
				<PromptInputActionMenuContent>
					<PromptInputActionAddAttachments />
					<PromptInputActionMenuItem
						onClick={(e) => {
							e.preventDefault();
							setDialogOpen(true);
						}}
					>
						<FolderOpenIcon className="mr-2 size-4 shrink-0" />
						<span className="whitespace-nowrap text-sm">
							{m.chat_myResourceLibrary()}
						</span>
					</PromptInputActionMenuItem>
				</PromptInputActionMenuContent>
			</PromptInputActionMenu>
			<ResourcePickerDialog
				open={dialogOpen}
				onOpenChange={setDialogOpen}
				onConfirm={handleConfirm}
			/>
		</>
	);
}
